import { type FC, type PropsWithChildren, type ReactNode } from 'react'
import { useIntl } from 'react-intl'

import { BrandIllustration } from '../../../brand-illustration'

type ProductPageOdsDialogHeaderProps = PropsWithChildren<{
  title: ReactNode
}>

export const ProductPageOdsDialogHeader: FC<
  ProductPageOdsDialogHeaderProps
> = ({ children, title }) => {
  const intl = useIntl()

  return (
    <div className="flex flex-col items-start tablet:flex-row">
      <BrandIllustration
        alt={intl.formatMessage({
          id: 'pdp.buyboxwithvariants.odsModal.image.alt',
        })}
        className="mx-auto mb-8 shrink-0"
        name="ods"
        size="m"
        type="dark"
      />
      <div className="tablet:pl-6">
        <h2 className="text-xl">{title}</h2>
        {children}
      </div>
    </div>
  )
}
